
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.922 3.914c-.396.094-.64.23-.735.406-.093.177-.14.615-.14 1.313v1.46c0 1.412-.305 2.428-.914 3.048-.61.614-1.526.93-2.75.945v3.273H5.086v-3.273c-1.245-.01-2.167-.305-2.766-.883-.599-.583-.898-1.515-.898-2.797V5.633c0-.604-.044-1.018-.133-1.242-.088-.23-.338-.388-.75-.477v-.383h2.242v3.727c0 1.135.18 1.937.54 2.406.359.469.947.734 1.765.797V.21h1.297v10.25c.88-.089 1.484-.373 1.812-.852.328-.484.492-1.278.492-2.382V3.53h2.235v.383z","fill":"currentColor"}})])
          )
        }
      }
    